import React from 'react';
import "./index.scss";

const DocumentThumbnail = ({ variant, savedJob, hidden }) => {
    if (hidden) return null;

    const renderResumeSnippet = () => {
        if (!savedJob?.resume) return null;
        
        const resume = savedJob.resume;
        return (
            <div className="resume-snippet">
                <div className="header">
                    <div className="name">{`${resume.firstName} ${resume.lastName}`}</div>
                    <div className="title">{resume.title}</div>
                </div>
                <div className="summary">{resume.summary?.substring(0, 150)}...</div>
            </div>
        );
    };

    const renderCoverLetterSnippet = () => {
        if (!savedJob?.application?.coverLetterText) return null;
        
        return (
            <div className="cover-letter-snippet">
                {savedJob.application.coverLetterText.substring(0, 200)}...
            </div>
        );
    };

    return (
        <div className={`document-thumbnail ${variant}`}>
            {variant === 'resume' && renderResumeSnippet()}
            {variant === 'cover' && renderCoverLetterSnippet()}
        </div>
    );
};

export default DocumentThumbnail;